"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _layout = require("../layout");

var _button = require("../button");

var _icons = require("../icons");

var _Trigger = require("./Trigger");

var _core = require("@emotion/core");

var ButtonTrigger = function ButtonTrigger(_ref) {
  var isOpen = _ref.isOpen,
      children = _ref.children,
      onClick = _ref.onClick,
      ariaHasPopup = _ref['aria-haspopup'];
  return (0, _core.jsx)(_button.Button, {
    "data-test-component": "PopoverTrigger",
    "aria-expanded": isOpen,
    "aria-haspopup": ariaHasPopup,
    "aria-controls": 'popoverContent',
    hasIcon: true,
    onClick: onClick,
    alignItems: "center"
  }, children, (0, _core.jsx)(_layout.Spacer, {
    width: 8
  }), (0, _core.jsx)(_Trigger.IconWrapper, {
    isOpen: isOpen
  }, (0, _core.jsx)(_icons.IconChevronDownSmall, {
    "aria-hidden": true
  })));
};

ButtonTrigger.propTypes = {
  children: _propTypes.default.node,
  onClick: _propTypes.default.func,
  isOpen: _propTypes.default.bool,
  'aria-haspopup': _propTypes.default.string
};
var _default = ButtonTrigger;
exports.default = _default;